import { connect } from 'react-redux';
// eslint-disable-next-line import/no-cycle
import PoStrategyComponent from '../../components/basic/PoStrategy/PoStrategy';

const mapStateToProps = state => {
  return {
    entityManager: state.entityManager,
  };
};

const PoStrategy = connect(mapStateToProps)(PoStrategyComponent);

export default PoStrategy;
